export const ROLE_LABELS = { admin: 'Admin', editor: 'Editor', viewer: 'Viewer' };
export const ROLE_COLORS = { admin: '#7C5CFC', editor: '#4F8EF7', viewer: '#45B26B' };
export const AVATAR_COLORS = ['#4F8EF7', '#7C5CFC', '#45B26B', '#F2994A', '#E85555', '#EB5757', '#F2C94C', '#56CCF2'];

export function timeAgo(dateStr) {
  if (!dateStr) return 'Never';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
}

export function menuItemStyle(theme) {
  return {
    width: '100%', padding: '7px 12px', background: 'none',
    border: 'none', borderRadius: 5, color: theme.textSecondary,
    fontSize: 11, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
  };
}

export function actionLabel(action) {
  const labels = {
    login: 'Logged in',
    google_login: 'Google login',
    agent_google_login: 'Agent login',
    register: 'Registered',
    password_change: 'Changed password',
    role_change: 'Role changed',
    user_deactivate: 'User deactivated',
    user_reactivate: 'User reactivated',
    user_invite: 'Invited user',
    user_update: 'Profile updated',
    admin_password_reset: 'Password reset by admin',
    upload: 'Uploaded fonts',
    font_delete: 'Deleted font',
    activate: 'Activated font',
    deactivate: 'Deactivated font',
    tag_font: 'Tagged font',
    favorite: 'Favorited font',
    unfavorite: 'Unfavorited font',
  };
  return labels[action] || action;
}
